/*
 | ==================================================
 | This File is for member hub rewards state handling
 | ==================================================
 */

// Fresh object per store init — the previous shared module-scope object would
// leak state across $reset() and break persisted-state hydration.
export default () => {
  return {
    rewards: [],
    rewards_fetched_at: null,
    rewards_user_id: null,
    rewards_revision: 0
  }
}
